import React from "react";
import styled, { keyframes } from "styled-components";
import { prop } from "styled-tools";

/*
 * Styles
 */

const GIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
`;

const G = styled.g`
  animation: ${GIn} 1800ms ${prop(
  "theme.settings.easings.quintOut"
)} 150ms backwards};
  &:nth-of-type(3n + 2) {
    animation-delay: 300ms;
  }
  &:nth-of-type(3n + 3) {
    animation-delay: 450ms;
  }
`;

const Path = styled.path`
  fill: ${prop("theme.colors.grayTTT")};
`;

/*
 * Component
 */

const HaloPieSegment = (props) => (
  <G>
    <Path d={props.d}></Path>
  </G>
);

export default HaloPieSegment;
